
const cities = [
            // {value: 0, label: '',},
            {value: 1, label: "Москва",},
            {value: 2, label: "Московская обл.",},
            {value: 3, label: "Санкт-Петербург"},
            
            {value: 4, label: 'Майкоп'},
            {value: 5, label: "Горно-Алтайск", },
            {value: 6, label: "Благовещенск",},
            {value: 7, label: "Архангельск",  },
            {value: 8, label: "Астрахань",  },
            {value: 9, label: "Барнаул",  },
            {value: 10, label: "Уфа",  },
            {value: 11, label: "Белгород",  },
            {value: 12, label: "Брянск",  },
            {value: 13, label: "Улан-Удэ",  },
            {value: 14, label: "Владимир",  },
            {value: 15, label: "Муром",  },
            {value: 16, label: "Суздаль",  },
            {value: 17, label: "Волгоград", },
            {value: 18, label: "Вологда", },
            {value: 19, label: "Череповец", },
            {value: 20, label: "Воронеж", },
            {value: 21, label: "Гомель", },
            {value: 22, label: "Махачкала", },
            {value: 23, label: "Биробиджан", },
            {value: 24, label: "Чита", },
            {value: 25, label: "Магас", },
            {value: 26, label: "Иваново", },
            {value: 27, label: "Иркутск", },
            {value: 28, label: "Нальчик", },
            {value: 29, label: "Элиста", },
            {value: 30, label: "Черкесск", },
            {value: 31, label: "Якутск", },
            {value: 32, label: "Сыктывкар", },
            {value: 33, label: "Петрозаводск", },
            {value: 34, label: "Евпатория", },
            {value: 35, label: "Керчь", },
            {value: 36, label: "Феодосия", },
            {value: 37, label: "Ялта", },
            {value: 38, label: "Симферополь", },
            {value: 39, label: "Севастополь", },
            {value: 40, label: "Петропавловск-Камчатский", },
            {value: 41, label: "Анапа", },
            {value: 42, label: "Краснодар", },
            {value: 43, label: "Геленджик", },
            {value: 44, label: "Новороссийск", },
            {value: 45, label: "Сочи", },
            {value: 46, label: "Красноярск", },
            {value: 47, label: "Норильск", },
            {value: 48, label: "Салехард", },
            {value: 49, label: "Калининград ", },
            {value: 50, label: "Калуга", },
            {value: 51, label: "Кемерово", },
            {value: 52, label: "Киров", },
            {value: 53, label: "Кострома", },
            {value: 54, label: "Курган", },
            {value: 55, label: "Курск", },           
            {value: 56, label: "Выборг", },
            {value: 57, label: "Гатчина", },
            {value: 58, label: "Елец", },
            {value: 59, label: "Липецк", },            
            {value: 60, label: "Луганск", },            
            {value: 61, label: "Йошкар-Ола", },           
            {value: 62, label: "Саранск", },            
            {value: 63, label: "Магадан", },
            {value: 64, label: "Мурманск", },           
            {value: 65, label: "Минск", },            
            {value: 66, label: "Нижний Новгород", },           
            {value: 67, label: "Валдай", },
            {value: 68, label: "Великий Новгород", },           
            {value: 69, label: "Новосибирск", },
            {value: 70, label: "Нарьян-Мар", },
            {value: 71, label: "Омск", },            
            {value: 72, label: "Оренбург", },          
            {value: 73, label: "Орел", },
            {value: 74, label: "Пермь", },
            {value: 75, label: "Соликамск", },
            {value: 76, label: "Владивосток", },
            {value: 77, label: "Пенза", },
            {value: 78, label: "Псков", },
            {value: 79, label: "Ростов-на-Дону", },
            {value: 80, label: "Таганрог", },            
            {value: 81, label: "Рязань", },
            {value: 82, label: "Владикавказ", },
            {value: 83, label: "Кисловодск", },
            {value: 84, label: "Пятигорск", },
            {value: 85, label: "Ставрополь", },
            {value: 86, label: "Самара", },
            {value: 87, label: "Тольятти", },
            {value: 88, label: "Саратов", },
            {value: 89, label: "Южно-Сахалинск", },
            {value: 90, label: "Екатеринбург", },
            {value: 91, label: "Нижний Тагил", },
            {value: 92, label: "Смоленск", },
            {value: 93, label: "Казань", },
            {value: 94, label: "Набережные Челны", },
            {value: 95, label: "Кызыл", },
            {value: 96, label: "Тамбов", },
            {value: 97, label: "Тверь", },
            {value: 98, label: "Ржев", },
            {value: 99, label: "Томск", },
            {value: 100, label: "Тула", },
            {value: 101, label: "Тюмень", },
            {value: 102, label: "Ижевск", },
            {value: 103, label: "Ульяновск", },
            {value: 104, label: "Абакан", },
            {value: 105, label: "Хабаровск", },
            {value: 106, label: "Ханты-Мансийск", },
            {value: 107, label: "Грозный", },
            {value: 108, label: "Чебоксары", },
            {value: 109, label: "Челябинск", },
            {value: 110, label: "Анадырь", },
            {value: 111, label: "Ростов Великий", },
            {value: 112, label: "Рыбинск", },
            {value: 113, label: "Ярославль", },
];

export default cities;